/*
  Hero slideshow (sections/carousel2.liquid): loads slide images on demand.

  Slide 1 is rendered with its real src/srcset, eager and preloaded. Every other slide carries
  them in data-src / data-srcset and downloads nothing until this script moves them into place:
  the selected slide and the one after it as soon as a slide is selected, and the one before it
  (for a backwards swipe) at low priority a moment later, or at once on pointer down.

  Flickity (theme.js, Slideshow class) marks the selected cell with .is-selected, so watching
  that class is all that is needed: no dependence on the Flickity API, and the theme editor's
  block select (which calls selectCell) is covered too.
*/
(function () {
  'use strict';

  var SLIDE = '.slideshow__slide';
  var SELECTED = 'is-selected';
  var PREV_DELAY = 1200;

  function arm(slide, priority) {
    if (!slide || slide.hasAttribute('data-armed')) return;
    slide.setAttribute('data-armed', '');
    // <source> first so the browser has the right candidate list when the <img> gets its src
    slide.querySelectorAll('source[data-srcset]').forEach(function (source) {
      source.setAttribute('srcset', source.getAttribute('data-srcset'));
      source.removeAttribute('data-srcset');
    });
    slide.querySelectorAll('img[data-src]').forEach(function (img) {
      if (priority) img.setAttribute('fetchpriority', priority);
      if (img.hasAttribute('data-srcset')) {
        img.setAttribute('srcset', img.getAttribute('data-srcset'));
        img.removeAttribute('data-srcset');
      }
      img.setAttribute('src', img.getAttribute('data-src'));
      img.removeAttribute('data-src');
    });
  }

  function slidesOf(wrapper) {
    return Array.prototype.filter.call(wrapper.querySelectorAll(SLIDE), function (el) {
      return el.closest('[data-slideshow-wrapper]') === wrapper;
    });
  }

  function neighbours(wrapper, slide) {
    var slides = slidesOf(wrapper);
    var n = slides.length;
    var i = slides.indexOf(slide);
    if (i < 0 || n < 2) return { next: null, prev: null };
    return { next: slides[(i + 1) % n], prev: slides[(i - 1 + n) % n] };
  }

  function watch(wrapper) {
    if (!wrapper || wrapper.heroSlideshowWatched) return;
    wrapper.heroSlideshowWatched = true;

    var current = null;
    var prevTimer = 0;

    function update() {
      var selected = wrapper.querySelector(SLIDE + '.' + SELECTED);
      if (!selected || selected === current) return;
      current = selected;
      var around = neighbours(wrapper, selected);
      arm(selected, 'high');
      arm(around.next, 'auto');
      clearTimeout(prevTimer);
      prevTimer = setTimeout(function () { arm(around.prev, 'low'); }, PREV_DELAY);
    }

    new MutationObserver(update).observe(wrapper, { subtree: true, attributes: true, attributeFilter: ['class'] });
    wrapper.addEventListener('pointerdown', function () {
      if (current) arm(neighbours(wrapper, current).prev, 'auto');
    }, { passive: true });
    update();
  }

  class HeroSlideshow extends HTMLElement {
    connectedCallback() {
      watch(this.querySelector('[data-slideshow-wrapper]'));
    }
  }

  if (window.customElements && !customElements.get('hero-slideshow')) {
    customElements.define('hero-slideshow', HeroSlideshow);
  }
})();
